import InlineComponent from './inlineComponent.jsx';
import ServiceCheckTextbox from '../../../components/output_textbox/ServiceCheckTextbox.jsx';

module.exports = class OutputRenderer extends InlineComponent {
  define() {
    this.component = ServiceCheckTextbox;
    this.data = {
      logUrl: this.element.data('logurl'),
      output: this.element.data('output'),
      search: this.element.data('search'),
      updateChannel: this.element.data('updatechannel'),
      nodeGroup: this.element.data('nodegroup'),
    };
  }
};
